import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TPaymentRegisterListGetReq,
  TPaymentRegisterListGetRes,
  TPaymentRegisterListPutReq,
} from "./TPayment"

/**
 * 支払明細一覧に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class PaymentListService extends ConnectApi {
  /**
   * 支払明細一覧取得
   *
   * @param {TPaymentRegisterListGetReq} params
   * @param {(param: TApiResponse<TPaymentRegisterListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TPaymentRegisterListGetRes[]>) => any} reject
   * @memberof paymentListService
   */
  getList = async (
    params: TPaymentRegisterListGetReq,
    resolve?: (param: TApiResponse<TPaymentRegisterListGetRes[]>) => any,
    reject?: (
      param: TApiResponse<TPaymentRegisterListGetRes[]> | undefined
    ) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TPaymentRegisterListGetRes[]>> =
        await this.getInner(`/billing/siharaimeisai`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TPaymentRegisterListGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 支払明細一覧更新
   *
   * @param {TPaymentRegisterListPutReq} data
   * @param {(param: TApiResponse<TPaymentRegisterListGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TPaymentRegisterListGetRes>>) => any} reject
   * @memberof paymentListService
   */
  put = async (id: number, data: TPaymentRegisterListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/billing/siharaimeisai/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
